import ApiService from './api.service'

class AffiliateReferralError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const AffiliateReferralService = {
    /**
     * Fetch affiliate stages 
     * 
     * @returns array of stages, 
     * @throws AppError 
    **/
    fetchStages: async function() {
        try {
            const response = await ApiService.get('/affiliate/stages')
            
            return response.data
        } catch (error) {
            throw new AffiliateReferralError(error.response.status, error.response.data.detail)
        }
    },
}

export { AffiliateReferralService, AffiliateReferralError }
